var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-heading',[_c('portal',{attrs:{"to":"title"}},[_c('img',{attrs:{"src":require("../assets/images/icon-QR.svg"),"alt":""}}),_c('span',[_vm._v("Not Found")])]),_c('h3',[_vm._v("Page Not Found")]),_c('p',[_vm._v("This page does not exist, double check your link.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }